import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { config } from './PurchaseVatReportConfig';
import IrdView from '../../common/irdReport/IrdView';
import { DOMAIN } from '../../../data/enums/enums';
import withBaseState from '../../common/withBaseState';
import * as queryService from '../../common/query.service';
import { defaultHeaderConfig } from '../../common/irdReport/config';
import * as downloadService from '../../../views/common/download.service';
import { PURCHASE_VAT_REPORT_CONFIG } from '../../common/domain.config';
import { clone } from '../../../utils/arrayProcessor';
import { getIrdPurchaseColumnTotals } from '../../../utils/handlers';
import * as snackService from '../../common/snack.service';
import {groupPrintDataSet} from "../../common/print.service";
import VatReportStyle from '../NewSRNVatReport/VatReportStyle';
import {onRowItemClick} from "../../fundamentals/common/helpers";

class PurchaseVatReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSet: [],
      display: {
        searchBox: false,
        filter: false,
      },
      dataList: [],
      totalData: 1,
      nepaliDate: {
        start: '',
        end: '',
      },
      columnTotal: {
        totalSales: 0,
        taxExemptedPurchase: 0,
        exportPurchase: 0,
        discount: 0,
        totalTaxableAmount: 0,
        vat: 0,
      },
      printData: {
        list: [],
        total: {},
      },
      printButtonClicked: false,
      queryParameters: { ...queryService.queryParameters },
    };
    const { downloadList } = this.props;
    this.dataListLength = 0;
    this.basePaginationService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.loadTableData,
      this.downloadList,
    );
    this.basePaginationService.resetFilter();
  }

  /** adjust table width and height according to screen * */
  componentDidMount() {
    this.loadTableData();
    window.addEventListener('keydown', this.handleKeyDown);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('contextmenu', this.handleMouseClick);
  }

  loadTableData = async(print=false) => {
    const self = this;
    const { getList } = this.props;
    const { queryParameters } = this.state;
    let query = clone(queryParameters);
    query.pagination.limit = 2000;
    await getList(print ? query:queryParameters)
      .then(response => {
        const nepaliDate = {
          start: response.nepali_date.start_date_nepali,
          end: response.nepali_date.end_date_nepali,
        };
        const columnTotal = getIrdPurchaseColumnTotals(response);
        const data = response.list;
        self.setState({
          dataSet: data,
          totalData: response.total,
          nepaliDate,
          columnTotal,
        },() => print && this.groupPrintDataSetNew());
      })
      .catch(error => {
        console.error(error);
        this.sendErrorMessage();
      });
  };

  sendErrorMessage = (message = 'Error while fetching data') => {
    const snack = snackService.generateFailureMessage(message);
    this.setState({ snack });
  };

  handleDownloadClick = (type, index) => {
    const { user, downloadList } = this.props;
    const { queryParameters } = this.state;
    const domain = index === 3 ? DOMAIN.NET_PURCHASE_VAT : DOMAIN.PURCHASE_VAT;
    downloadList({
      type,
      query: queryParameters,
      extraString: `&user_id=${user.idUsers}`,
      domain,
    }).then(response => downloadService.resolver(response));
  };

  handlePrintClick = async () => {
    const self = this;
    await this.loadTableData(true);
    self.setState({ printButtonClicked: true }, () => {
      setTimeout(() => {
        window.print();
      }, 500);
    });
    window.onafterprint = function () {
      self.setState({ printButtonClicked: false });
    };
  };
  groupPrintDataSetNew() {
    const { dataSet  } = this.state;
    const {company} =this.props;
    const printInfoBill = {...company,printInfo:{...company.printInfo,batchEnabled:false}} || {};
    const orders = clone(dataSet);
    const dataList = groupPrintDataSet(orders, printInfoBill, config);
    this.setState({ dataList });
  }


  handleKeyDown = e => {
    const charCode = String.fromCharCode(e.which).toLowerCase();
    if ((e.ctrlKey && charCode === 'p') || (e.metaKey && charCode === 'p')) {
      e.preventDefault();
      this.handlePrintClick();
    }
  };

  handleMouseClick = e => {
    e.preventDefault();
    alert('Default menu stopped from poping up');
  };

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;

    this.setState(display);
  };

  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };
  render() {
    const {
      dataSet,
      display,
      dataList,
      totalData,
      nepaliDate,
      columnTotal,
      printButtonClicked,
      queryParameters,
      printData,
    } = this.state;
    const { company, serverResponseWaiting, getList } = this.props;
    return (
      <VatReportStyle>
      <div className="purchase-vat new-purchase-vat">
        <IrdView
          company={company}
          dataSet={dataSet}
          display={display}
          printList={dataList}
          tableConfig={config}
          totalData={totalData}
          nepaliDate={nepaliDate}
          columnTotal={columnTotal}
          printFlag={printButtonClicked}
          loading={serverResponseWaiting}
          queryParameters={queryParameters}
          printColumnTotal={printData.total}
          controlDisplay={this.controlDisplay}
          domainConfig={PURCHASE_VAT_REPORT_CONFIG}
          handlePrintClick={this.handlePrintClick}
          handleDownloadClick={this.handleDownloadClick}
          resetFilter={this.basePaginationService.resetFilter}
          headerConfig={{ ...defaultHeaderConfig, print: true }}
          handlePageSelect={this.basePaginationService.onPageSelect}
          handleTableSorting={this.basePaginationService.handleTableSorting}
          handleDateRangeChange={this.basePaginationService.handleDateRangeChange}
          disableUpperHeaderDetails={true}
          printFooterEnable ={false}
          onTableBodyClick={onRowItemClick}
        />
      </div>
      </VatReportStyle>
    );
  }
}

PurchaseVatReport.contextTypes = {
  router: PropTypes.object,
};

const CustomerWithState = withBaseState(PurchaseVatReport);

export default CustomerWithState;
PurchaseVatReport.propTypes = {
  serverResponseWaiting: PropTypes.bool,
  company: PropTypes.shape({
    address: PropTypes.string,
    panNumber: PropTypes.number,
    title: PropTypes.string,
    phone: PropTypes.string,
  }),
};

PurchaseVatReport.defaultProps = {
  company: {},
  serverResponseWaiting: false,
};
